import React, { useState } from "react";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import { Row, Col, Container } from "react-bootstrap";
import Fonts from "../../../../../stories/assets/Fonts";
import { BackwardArrow } from "../../../../../constant/imagePath";
import Colors from "../../../../../stories/assets/Colors";
import { ReactSVG } from "react-svg";
import classes from "./MapWithCoachesModal.module.css";
import FavouriteDetailCardsMobile from "../../../../../stories/FavouriteDetailCards/FavouriteDetailCardsMobile";
import Map from "../../../../Maps";

import ScrollContainer from "react-indiana-drag-scroll";

const MapWithCoachesModal = ({ show, setShow, coachesData, onCard }) => {
  const [tabState, setTabState] = useState("Day");

  const favCardsArr = [
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
  ];

  return (
    <>
      <style>{`
          .modal .modal-dialog {
            width: 100% !important;
            margin: 0px !important;
          }
          .modal .modal-dialog {
            max-width: 100% !important;
            height: 100%;
        }
        .modal-content{
            min-height:100%
        }
        .modal-body {
          padding: 0px !important;
        }
        .modal { 
            border-radius: 0px;
            background: white;
          }
    `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        borderRadius={"0px"}
        width={"100%"}
      >
        <Container fluid className={["p-0"].join(" ")}>
          <div
            style={{
              borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
            }}
            className={[classes.ChatHeader].join(" ")}
          >
            <div
              className={[
                classes.dflex,
                classes.itemscenter,
                classes.w100,
              ].join(" ")}
            >
              <ReactSVG src={BackwardArrow} onClick={() => setShow(false)} />
              <div
                className={[
                  classes.dFlexJustifyContentCenter,
                  classes.mr16,
                  classes.w100,
                ].join(" ")}
              >
                <p
                  style={{
                    ...Fonts.b3,
                    color: Colors.neutralShadesOfNero,
                    lineHeight: "14px",
                    lineHeight: "20px",
                  }}
                  className={[classes.pl16].join(" ")}
                >
                  Search on Map
                </p>
              </div>
            </div>
          </div>
          <Row className="g-0" style={{ height: "99.5vh" }}>
            <Col md={12}>
              <Map type="map" className={classes.map} location={{ lat: 32.715736, lng: -117.161087 }} />
            </Col>
          </Row>
          <div className={classes.cards}>
            <div className={classes.indiana_container}>
              <ScrollContainer className={classes?.container}>
                {favCardsArr?.map((item, index) => (
                  <FavouriteDetailCardsMobile
                    key={index}
                    data={item}
                    onClick={onCard}
                  />
                ))}
              </ScrollContainer>
            </div>
          </div>
        </Container>
      </ModalSkeleton>
    </>
  );
};
export default MapWithCoachesModal;
